<span class="payment-method-display">
  <link rel="stylesheet" />
  @switch (paymentMethod?.type) {
    @case (PaymentMethodType.CARD) {
      @if (CARD_BRAND_TO_ICON_SRC[paymentMethod?.details?.cardType?.id]; as iconURL) {
        <img [src]="iconURL" class="payment-method-icon card-logo" />
      } @else {
        <mat-icon class="payment-method-icon"> credit_card </mat-icon>
      }
      <span>**** **** **** {{ paymentMethod?.details?.lastFourDigits }}</span>
      <span class="expiry-text"
        >({{ 'PAYMENT_METHOD_SELECTOR.EXPIRES' | translate }} {{ paymentMethod?.details?.expiryMonth }}/{{
          paymentMethod?.details?.expiryYear?.toString() | slice: -2
        }})</span
      >
    }
    @case (PaymentMethodType.ACH_DEBIT) {
      <ng-container *ngTemplateOutlet="bankAccount"></ng-container>
    }
    @case (PaymentMethodType.ACSS_DEBIT) {
      <ng-container *ngTemplateOutlet="bankAccount"></ng-container>
    }
  }
  <ng-template #bankAccount>
    <mat-icon class="payment-method-icon"> account_balance </mat-icon>
    <span>******** {{ paymentMethod?.details?.lastFourDigits }}</span>
  </ng-template>
</span>
